<div class="pinInputWrapper">
  <div class="ic1-flex">
    <ng-container *ngIf="refreshOtp">
      <ng-ui-kit-otp
        #ngUiKitOtp
        [icId]="'pin-input-' + (formControlName || 'pin')"
        [type]="'number'"
        [title]="resolvedLabel"
        [resendBtn]="resendBtnConfig"
        [length]="pinLength"
        [disabled]="disabled"
        [error]="error"
        [disclaimerText]="error && errorDisclaimerText ? errorDisclaimerText : ''"
        [hideValue]="hideValue"
        (onChange)="onChange($event)"
        (keydown.enter)="onEnter($event)">
      </ng-ui-kit-otp>
    </ng-container>
  </div>
</div>
